import { parse as _parse } from 'date-fns/parse';

import { DATE_FORMAT, DATE_FORMAT_ISO } from '.';

export const parse = (date: string, format?: string) =>
  _parse(date, format ?? DATE_FORMAT, new Date(), {
    weekStartsOn: 1,
  });

export const parseISO = (date: string) =>
  _parse(date, DATE_FORMAT_ISO, new Date(), {
    weekStartsOn: 1,
  });
